import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useSavingsSummaryStyles = makeStyles({
    root: {
        backgroundColor: tokens.colorBrandForeground2,
        ...shorthands.borderRadius(tokens.borderRadiusXLarge),
        width: '100%'
    },
    contentWrapper: {
        ...shorthands.padding(tokens.spacingVerticalXL)
    },
    title: {
        fontSize: tokens.fontSizeBase500,
        fontWeight: tokens.fontWeightBold
    },
    lineBreak: {
        ...shorthands.margin(tokens.spacingVerticalL, '0')
    }
});
